import '~/js/modules/stickyNav';
import '~/js/modules/section-hero';

const $levelSelect = $('#levelSelect');
const $resortSelect = $('#js-resort-select');

function calculateCountResults() {
  let countResults = 0;

  $('.js-dive-level.show').each(function selectAllLevels() {
    if ($(this).is(':visible')) {
      countResults++;
    }
  });
  $('.js-results-summary-count').text(countResults);
}

$levelSelect.change(function levelSelectHandler() {
  const diveLevel = $(this).val();

  $('.js-tabs-item').removeClass('active');
  $('.js-tabs-item[data-select-level="' + diveLevel + '"]').addClass('active');
  $('.js-dive-level').removeClass('show');
  $('[data-level="' + diveLevel + '"]').addClass('show');
  if ( + diveLevel === 4) {
    $('.js-dive-level').addClass('show');
  }
  calculateCountResults();
});

$resortSelect.change(function resortSelectHandler() {
  const resortCode = $(this).val();

  this.elem = document.querySelector('#dive-levels');

  $('.js-dive-resorts-list').addClass('show');
  $('.js-dive-levels-select').addClass('show');
  $('.js-resort-brand').removeClass('show');
  $('.js-dive-resort').removeClass('show');
  $('[data-resort="' + resortCode + '"]').addClass('show');
  if (!$('.js-tabs-item.active').length) {
    $('[data-select-level="4"]').addClass('active');
    $('.js-dive-level').addClass('show');
  }
  calculateCountResults();

  const startPos = window.pageYOffset;
  const elemPos = this.elem.offsetTop;
  const count = 100;
  const time = 300;
  const distance = elemPos - 110 - startPos;
  let step = count;
  const interval = setInterval(() => {
    if (step > 1) {
      window.scroll(0, startPos + (distance - distance / count * step));
      step *= 0.975;
    } else {
      clearInterval(interval);
    }
  }, time / count);
});

$(document).on('click', '[data-select-level]', function selectLevel() {
  const diveLevel = Number($(this).data('select-level'));

  $(this).addClass('active').siblings().removeClass('active');
  $('.js-dive-level').removeClass('show');
  $('[data-level="' + diveLevel + '"]').addClass('show');
  if (diveLevel === 4) {
    $('.js-dive-level').addClass('show');
  }
  calculateCountResults();
});
